$(window).resize(function() {

  if ( window.innerWidth != width ) {

    if (typeof bulletin != "undefined" && bulletin != null) {
        setHeaderTop()
      }
  }

  //height = $(window).height();
  width = window.innerWidth;






});
